export function seoLink(title: string): string {
  const charMap: Record<string, string> = {
    ą: "a",
    ć: "c",
    ę: "e",
    ł: "l",
    ń: "n",
    ó: "o",
    ś: "s",
    ź: "z",
    ż: "z",
  };

  let seoTitle = title.toLowerCase();

  Object.keys(charMap).forEach(key => {
    const reg = new RegExp(key, "g");
    seoTitle = seoTitle.replace(reg, charMap[key]);
  });

  seoTitle = seoTitle
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes

  return seoTitle;
}

export const formattedPriceToPLN = (priceString: string) =>
  parseFloat(priceString.toString()).toLocaleString("pl-PL", {
    style: "currency",
    currency: "PLN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });

export const generateId = () => Math.random().toString(36).substr(2, 9);

export const cleanObject = (params: {
  [key: string]: any;
}): { [key: string]: any } =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value || value),
  );

export const checkPhoneNumber = (value: string, previousValue: string) => {
  const regex = /^(?:[0-9+\s()-]+|)$/;
  if (regex.test(value)) {
    return value;
  }
  return previousValue;
};
